const o = [
  /*
   * Third-party analytics: Usercentrics/Amplitude/GTM
   */
  // TODO: Add list
  /*
   * Just network-related issues.
   */
  "error loading dynamically imported module",
  "Failed to fetch dynamically imported module",
  "Importing a module script failed",
  "Failed to fetch"
], d = ["gtm.js", "node_modules/draft-js"];
export {
  o as DEFAULT_IGNORE_ERRORS_LIST,
  d as DEFAULT_IGNORE_ERROR_SOURCES_LIST
};
//# sourceMappingURL=SentryMonitoring.consts.mjs.map
